const removeSwipeSdk = (): void => {
  try {
    const swipeSdkContainer = document.getElementById('swipe-sdk-container');
    if (swipeSdkContainer) {
      swipeSdkContainer.remove();
    }
  } catch (e) {
    console.error(e);
  }
};

export default removeSwipeSdk;
